module.exports = __webpack_public_path__ + "img/logo--heidiland.3204f38b.svg";